import axios from "axios"

const API_URL = process.env.REACT_APP_BASE_URL+'/manager/restriction';
const token = localStorage.getItem('token');

const headers = () => ({
  headers: {
    Authorization: token,
  },
});

export const getRestrictions = () => {
  return axios.get(API_URL+'/list', headers());
};

export const createRestriction = (data) => {
  return axios.post(API_URL+'/create', data, headers());
};

export const updateRestriction = (id, data) => {
  return axios.put(`${API_URL}/update/${id}`, data, headers());
};

export const deleteRestriction = (id) => {
  return axios.delete(`${API_URL}/${id}`, headers());
};

export const assignRestrictionToUser = (data) => {
  return axios.post(`${API_URL}/assign`, data, headers());
};

export const getUserRestrictions = (userId) => {
  return axios.get(`${API_URL}/user/${userId}`, headers());
};

export const removeUserRestriction = (id) => {
  return axios.delete(`${API_URL}/user-restriction/${id}`, headers());
};

export const checkRestriction = (userId, code) => {
  return axios.get(`${API_URL}/check?userId=${userId}&code=${code}`, headers());
};